import { createReducer, on } from '@ngrx/store';

import { PermissionListDto, PermissionListSearchCriteria } from '../../models/permission-list.model';
import { PermissionActions } from './permission.actions';

export interface PermissionListState {
  permissions: PermissionListDto[];
  totalElements: number;
  totalPages: number;
  criteria: PermissionListSearchCriteria;
}

const initialState: PermissionListState = {
  permissions: [],
  totalElements: 0,
  totalPages: 0,
  criteria: {
    searchCriteria: '',
    page: 1,
    size: 20
  }
};

export const PermissionListReducers = createReducer(
  initialState,
  on(PermissionActions.loadPermissions, (state, { criteria }) => ({
    ...state,
    criteria
  })),
  on(PermissionActions.loadPermissionsSuccess, (state, { permissions, totalElements, totalPages }) => ({
    ...state,
    permissions,
    totalElements,
    totalPages
  }))
);
